import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TranscribeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"transcribe"}/>
}
